module.exports = __webpack_public_path__ + "img/level1.png";